import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\src\\app\\courses\\page.js");
